export const MESSAGE_STATE_INFO = 'app:message:info';
export const MESSAGE_STATE_ERROR = 'app:message:error';
export const MESSAGE_STATE_SUCCESS = 'app:message:success';
